import { roomStatus } from '@/helpers'
import * as types from './mutations-types'

export const socketUserTypingStart = (context, user) => {
  if (context.getters.user && context.getters.user.email !== user.email) {
    context.commit(types.START_TYPING)
  }
}
export const socketUserTypingStop = (context, user) => {
  if (context.getters.user && context.getters.user.email !== user.email) {
    context.commit(types.STOP_TYPING)
  }
}
export const socketRoomUpdate = (context, room) => {
  context.dispatch('updateChat', { chat: room })

  context.dispatch('setUser', room.createdBy)

  context.dispatch('handleReopen', room)

  if (room.status === roomStatus.closed) {
    context.dispatch('closeConversation')
  }
}
